import { render } from "./ReservationPage.vue?vue&type=template&id=d0c0d19a&ts=true"
import script from "./ReservationPage.vue?vue&type=script&lang=ts"
export * from "./ReservationPage.vue?vue&type=script&lang=ts"

import "./ReservationPage.vue?vue&type=style&index=0&id=d0c0d19a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__